import { render, staticRenderFns } from "./MarketplaceAccessRequests.vue?vue&type=template&id=69896981&scoped=true"
import script from "./MarketplaceAccessRequests.vue?vue&type=script&lang=ts"
export * from "./MarketplaceAccessRequests.vue?vue&type=script&lang=ts"
import style0 from "./MarketplaceAccessRequests.vue?vue&type=style&index=0&id=69896981&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69896981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69896981')) {
      api.createRecord('69896981', component.options)
    } else {
      api.reload('69896981', component.options)
    }
    module.hot.accept("./MarketplaceAccessRequests.vue?vue&type=template&id=69896981&scoped=true", function () {
      api.rerender('69896981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/MarketplaceAccessRequests.vue"
export default component.exports